import React from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { IconEye, IconTerminal2 } from '@tabler/icons-react';
import { LogEventBadge, RUNNER_EVENTS } from './logEventUtils';

const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const DatatableCpanelLogs = ({
  listLogs,
  search,
  handleChangeSearch,
  handleShowLog,
  loading,
  paginationMeta,
  onChangePage,
  onChangePerPage,
}) => {
  const columns = [
    {
      name: 'Aksi',
      width: '148px',
      minWidth: '148px',
      allowOverflow: false,
      cell: (row) => (
        <div className="cpanel-log-actions d-flex flex-nowrap align-items-center gap-1">
          <button
            className="btn btn-sm btn-outline-info"
            type="button"
            title="Detail Log"
            onClick={() => handleShowLog(row)}
          >
            <IconEye stroke={2} />
          </button>
          {row.jobId && RUNNER_EVENTS.has(row.event) ? (
            <Link
              to={`/cpanel/jobs/${row.jobId}`}
              className="btn btn-sm btn-outline-primary"
              title="Buka Job Runner"
            >
              <IconTerminal2 stroke={2} />
            </Link>
          ) : null}
        </div>
      ),
    },
    {
      name: 'Waktu',
      width: '170px',
      minWidth: '170px',
      selector: (row) => row.createdAt || row.created_at || '',
      sortable: true,
      cell: (row) => formatDate(row.createdAt || row.created_at),
    },
    {
      name: 'Event',
      width: '120px',
      selector: (row) => row.event || '',
      sortable: true,
      cell: (row) => <LogEventBadge event={row.event} />,
    },
    {
      name: 'Deskripsi',
      grow: 1,
      selector: (row) => row.description || '',
      sortable: true,
      wrap: true,
    },
    {
      name: 'Pelaku',
      width: '140px',
      selector: (row) => row.causerName || '',
      sortable: true,
      cell: (row) => row.causerName || 'Sistem',
    },
    {
      name: 'Tenant Slug',
      width: '160px',
      selector: (row) => row.tenantSlug || '',
      sortable: true,
      cell: (row) => row.tenantSlug || '-',
    },
    {
      name: 'Log',
      width: '100px',
      selector: (row) => row.logName || row.log_name || '',
      cell: (row) => row.logName || row.log_name || '-',
    },
  ];

  return (
    <div className="cpanel-logs-datatable">
      <div className="cpanel-tenants-search mb-4">
        <input
          type="search"
          className="form-control form-control-sm"
          placeholder="Cari deskripsi, event, pelaku..."
          value={search}
          onChange={(e) => handleChangeSearch(e.target.value)}
        />
      </div>
      <DataTable
        className="cpanel-logs-datatable"
        columns={columns}
        data={listLogs}
        pagination
        paginationServer
        paginationTotalRows={paginationMeta?.total || 0}
        paginationDefaultPage={paginationMeta?.page || 1}
        paginationPerPage={paginationMeta?.limit || 25}
        paginationRowsPerPageOptions={[10, 25, 50, 100]}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangePerPage}
        progressPending={loading}
        highlightOnHover
        noDataComponent={
          <div className="py-5 text-muted">Belum ada log aktivitas.</div>
        }
        customStyles={{
          table: {
            style: {
              tableLayout: 'fixed',
            },
          },
        }}
      />
    </div>
  );
};

export default DatatableCpanelLogs;
